export const categories = [
  {
    id: "ent",
    name: "娱乐圈",
    icon: "ri-movie-2-line",
    desc: "顶流动态、人设争议、工作室回应，一线瓜最先落这里。",
    count: 189,
  },
  {
    id: "drama",
    name: "影视剧综",
    icon: "ri-clapperboard-line",
    desc: "定档、换角、番位、收官口碑，追剧人的深夜复盘区。",
    count: 142,
  },
  {
    id: "variety",
    name: "综艺现场",
    icon: "ri-live-line",
    desc: "剪辑争议、赛制公平、嘉宾表现，边看边吵最热闹。",
    count: 96,
  },
  {
    id: "live",
    name: "网红直播",
    icon: "ri-broadcast-line",
    desc: "直播翻车、带货售后、内容套路，围观与拆解都在这里。",
    count: 118,
  },
  {
    id: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    desc: "音乐节、巡演、重组与翻唱，现场的震撼和遗憾一起聊。",
    count: 74,
  },
  {
    id: "esports",
    name: "体育电竞",
    icon: "ri-gamepad-line",
    desc: "赛事争议、选手言论、解说风波，理性与情绪同场竞技。",
    count: 88,
  },
  {
    id: "tech",
    name: "数码科技",
    icon: "ri-smartphone-line",
    desc: "新品翻车、参数打脸、官方回应，科技圈的瓜也很香。",
    count: 63,
  },
];